/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
// library
import { yupResolver } from '@hookform/resolvers/yup';
import {
    Box,
    Button,
    ClickAwayListener,
    Container,
    Grid,
    Grow,
    InputAdornment,
    Paper,
    Popper,
    Stack,
    TextField,
} from '@mui/material';
import { isEmpty } from 'lodash';
import { useForm } from 'react-hook-form';
// components
import { Iconify } from '../../../../components';
import { FormProvider } from '../../../../components/hook-form';
import { NormalLoading } from '../../../../components/loading';
import CustomConfirmationDialog from './CustomConfirmationDialog';
// redux
import { archiveFromCurrentPracticeAndMove } from '../../../../redux/slices/lead';
import { dispatch, useSelector } from '../../../../redux/store';
// hooks/validations
import { useToggle } from '../../../../hooks';
import { inlinePracticeSchema } from '../../../../validations/validations';
// style
import {
    borderRadius,
    cancelButtonStyle,
    customTextFieldStartIconStyle,
    customTextFieldStyle,
    paperGridInnerBoxStyle,
    paperGridInnerContainerStyle,
    paperGridStyle,
    paperZIndex,
    reminderStackStyle,
    saveButtonStyle,
    searchTeamTextfieldStyle,
    treatmentBoxStyle,
    treatmentFooterStyle,
} from '../../../../styles/TreatmentEditPopover';
import PracticePopoverScrollbar from './PracticePopoverScrollbar';

export const CustomTextField = ({ search, searchbarHandler, isScript }) => {
    const inputRef = useRef();

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return <Box sx={customTextFieldStyle}>
        <TextField
            fullWidth
            onChange={(event) => searchbarHandler(event.target.value)}
            value={search}
            placeholder="Select Practice"
            disabled={isScript}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Iconify
                            icon={'eva:search-fill'}
                            sx={customTextFieldStartIconStyle}
                        />
                    </InputAdornment>
                ),
            }}
            inputRef={inputRef}
            sx={searchTeamTextfieldStyle}
        />
    </Box>;
};

const ChangePracticePopover = ({
    open,
    anchorEl,
    handleClickAwayLister,
    practiceId,
    handleReloadAPI,
    isScript,
    placement,
    currentRow
}) => {
    const [search, setSearch] = useState("");
    const [selected, setSelected] = useState('');
    const { treatmentsListV2 } = useSelector((state) => state.practiceTreatment);
    const { practiceTreatment } = useSelector((state) => state.practiceTreatmentList);
    const [position, setPosition] = useState(0);
    const listElem = useRef();
    const mounted = useRef();
    const dialogRef = useRef();
    const currentPracticeObject = practiceTreatment?.results?.filter(e => e?.id === practiceId)?.[0];

    const {
        toggle,
        onOpen,
        onClose,
    } = useToggle();

    const defaultValues = {
        selectedTreatment: currentPracticeObject?.name,
        selectedTreatmentId: currentPracticeObject?.id,
    };

    const methods = useForm({
        resolver: yupResolver(inlinePracticeSchema),
        defaultValues,
    });

    const {
        setValue,
        handleSubmit,
        getValues
    } = methods;

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true;
        } else if (position && listElem.current) {
            listElem.current.scrollTop = position - listElem?.current?.offsetHeight;
        }
    }, [position]);

    useEffect(() => {
        const currentPracticeObject = practiceTreatment?.results?.filter(e => e?.id === practiceId)?.[0];
        if (currentPracticeObject) {
            setSelected(currentPracticeObject?.name);
            setValue('selectedTreatment', currentPracticeObject?.name);
            setValue('selectedTreatmentId', currentPracticeObject?.id);
        }
    }, []);

    const handleNext = async () => {
        await handleSubmit(onSubmit)();
    };

    const treatmentSelected = (row) => {
        setSelected(row?.name);
        setValue('selectedTreatment', row?.name);
        setValue('selectedTreatmentId', row?.id);
    };

    const onSubmit = async () => {
        onOpen();
    };

    const handleSuccess = (status) => {
        handleReloadAPI(status);
        handleClickAwayLister();
    };

    const handleSubmitTreatmentChanges = async () => {
        onClose();
        const currentPracticeObject = practiceTreatment?.results?.filter(e => e?.id === practiceId)?.[0];
        dispatch(archiveFromCurrentPracticeAndMove(practiceId, getValues('selectedTreatmentId'), getValues('selectedTreatment'), currentPracticeObject?.name, currentRow, handleSuccess));
    };

    const searchbarHandler = (value) => {
        setSearch(value);
    };

    const handleScroll = (event) => {
        const listboxNode =
            event.target.scrollHeight <= event.target.scrollTop + event.target.clientHeight;
        if (listboxNode) {
            setPosition(event.target.scrollTop + event.target.clientHeight);
        }
    };

    return (
        <>
            <ClickAwayListener onClickAway={(e) => handleClickAwayLister(e, dialogRef)}>
                <Popper open={open} anchorEl={anchorEl} transition placement={placement} sx={paperZIndex}>
                    {({ TransitionProps }) => (
                        <Grow {...TransitionProps}>
                            <Paper sx={borderRadius}>
                                <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                    <Box sx={{ ...treatmentBoxStyle, width: "400px" }}>
                                        <Stack sx={reminderStackStyle}>
                                            <Grid container spacing={1} sx={paperGridStyle}>
                                                <Container maxWidth={'xl'} sx={paperGridInnerContainerStyle}>
                                                    <Box sx={paperGridInnerBoxStyle}>
                                                        <NormalLoading
                                                            tableData={treatmentsListV2 === null && 'No Found'}
                                                            pageCount={treatmentsListV2 === null && 'No Found'}
                                                        />
                                                        <Stack>
                                                            <CustomTextField search={search} searchbarHandler={searchbarHandler} isScript={isScript} />
                                                            <PracticePopoverScrollbar
                                                                practices={practiceTreatment?.results?.filter(e => e?.name?.toLowerCase()?.includes(search?.toLowerCase()) || search?.length === 0)}
                                                                selected={selected}
                                                                handleScroll={handleScroll}
                                                                handleTreatmentSelect={treatmentSelected}
                                                            />
                                                        </Stack>
                                                    </Box>
                                                </Container>
                                            </Grid>
                                        </Stack>
                                        <Box sx={treatmentFooterStyle}>
                                            <Button color="inherit" sx={cancelButtonStyle} onClick={(e) => handleClickAwayLister(e, dialogRef)}>
                                                Cancel
                                            </Button>
                                            <Button
                                                disabled={isEmpty(selected) || practiceId === getValues('selectedTreatmentId')}
                                                color="primary"
                                                variant="contained"
                                                onClick={handleNext}
                                                sx={saveButtonStyle}
                                            >
                                                Save
                                            </Button>
                                        </Box>
                                    </Box>
                                </FormProvider>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </ClickAwayListener>
            <CustomConfirmationDialog
                toggle={toggle}
                handleClose={(e) => { e.stopPropagation(); onClose(); }}
                handleSubmit={handleSubmitTreatmentChanges}
                message={<>
                    <span>Are you sure you want to move </span>
                    <span style={{ color: "#FFAB00" }}>{currentRow?.first_name} {currentRow?.last_name}</span>
                    <span> to Practice </span>
                    <span style={{ color: "#FF5630" }}>{getValues('selectedTreatment')}</span>
                </>}
                style={{ zIndex: '9999999' }}
                dialogRef={dialogRef}
                saveBtn='Archive & Move'
            />
        </>
    );
};

export default ChangePracticePopover;

ChangePracticePopover.defaultProps = {
    placement: "right-start"
}

ChangePracticePopover.propTypes = {
    open: PropTypes.bool,
    anchorEl: PropTypes.any,
    handleClickAwayLister: PropTypes.func,
    treatment: PropTypes.string,
    leadTreatmentSpecification: PropTypes.any,
    treatmentData: PropTypes.any,
    treatmentPrice: PropTypes.number,
    leadId: PropTypes.number,
    treatmentId: PropTypes.string,
    treatmentCategory: PropTypes.string,
    handleReloadAPI: PropTypes.func,
    isAddTreatment: PropTypes.bool,
    isFlow: PropTypes.bool,
    isScript: PropTypes.bool,
    handleSaveTreatment: PropTypes.func,
    placement: PropTypes.string,
    practiceId: PropTypes.number
};
CustomTextField.propTypes = {
    search: PropTypes.string,
    searchbarHandler: PropTypes.func,
    isScript: PropTypes.bool,
};
